import React from 'react'

const LoadingRow = () => {
  return (
    <tr className='text-center'><td colSpan={20}>Loading...</td></tr>
  )
}

export default LoadingRow